import React from 'react';

import { DivMiddleTag, ImageMiddleTag } from './MiddleTag.styled';

const MiddleTag = (props) => {
  const item = props.data;

  return (
    <div>
      {item.type === "div" ? (
        <DivMiddleTag styleString={item.style} />
      ) : item.type === "image" ? (
        <ImageMiddleTag src={item.src} styleString={item.style} /> 
      ) : (
        <></>
      )}
    </div>
  );
};

export default MiddleTag;



// WEBPACK FOOTER //
// ./src/components/preview/MiddleTag.tsx